<template>
  <div class="TupianKeywords pic-tag">
    <a
      v-if="vo.link != ''"
      :href="vo.link"
      target="_blank"
      v-for="(vo,idx) in keywordList.slice(0, maxNumber)" :key="idx"
    >{{ vo.label }}
    </a>

    <!-- 不可跳转 -->
    <a
      v-else
      @click.prevent=""
      :href="vo.link"
      target="_blank"
      v-for="(vo,idx) in keywordList.slice(0, maxNumber)" :key="idx"
    >{{ vo.label }}
    </a>
  </div>
</template>

<script>
import { PAGE_PATH } from '@/constant/PAGE_PATH'
export default {
  name: "TupianKeywords",
  props:{
    keywordList:{
      type: Array,
      default:()=>{
        return [
          { "label" : '测试关键词' },
          { "label" : '测试关键词2' },
        ]
      }
    },

    /* 限制词数量 */
    maxNumber: {
      type: String | Number,
      default: 100
    }
  },
  data(){
    return{
      PAGE_PATH
    }
  }
}
</script>

<style lang="scss" scoped>
.pic-tag {
  display: flex;
  flex-wrap: wrap;
  width: 660px;

  a {
    //width: 42px;
    padding: 0 8px;
    height: 26px;
    line-height: 26px;
    background: #F5F6FA;
    border-radius: 13px;
    font-size: 13px;
    color: #596088;
    margin: 0 8px 8px 0;

    @include ElementHover(#6969FF, #EEEEFF);

  }
}
</style>
